import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { StreamField } from "@thelabnyc/thelabui/src/components/StreamField";

import { InformationHeroBanner } from "../../blocks/InformationHeroBanner";
import { toolboxComponentsMap } from "../../blocks/toolboxComponentsMap";

/**
 * sealy ReviewsPage body assembly (#33585): ``ReviewsPageBodyContent`` = the
 * 30 Toolbox keys + ``hero_banner`` (``InformationHeroBanner``, the same
 * block the InformationPage assembly dispatches -- a real ported component
 * as of #33285 batch B; no legacy HTML-string keys remain here).
 *
 * Only the body loop is assembled here; the full-document ReviewsPageTemplate
 * renders the love-root breadcrumb chrome above and the reviews SPA below
 * this body.
 *
 * FAITHFUL port of the legacy ``cms/reviews_page.html`` body render (verified
 * at git dev): a bare ``{% for %}{% include_block %}`` loop -- NO per-block
 * Wagtail ``w-block-*`` wrapper, reproduced with
 * ``tagName={React.Fragment}``.
 */
export const reviewsPageComponentsMap = {
    ...toolboxComponentsMap,
    hero_banner: InformationHeroBanner,
} as const;

export const ReviewsPageBody = (
    props: Immutable<{
        page: Pick<templates.ReviewsPageDocumentTemplate["page"], "body">;
    }>,
): React.JSX.Element => {
    // `body` is non-null (the model field is `blank=True` without
    // `null=True`); an empty stream renders nothing.
    return (
        <StreamField
            tagName={React.Fragment}
            value={props.page.body.value}
            components={reviewsPageComponentsMap}
        />
    );
};
